let m, edgeType=1;
const shuffleArray=array => {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}
const getDegree=(n,e=edgeType)=>n.descendants().add(n)
  .reduce((a,x)=>(e?(a.i+=x.indegree(),a.o+=x.outdegree()):a+=x.degree(),a),e?{i:0,o:0}:0)
const degreeExchange=(cn,d,cp)=>edgeType?
  d.i*(cn.o+d.o-cp.o)+d.o*(cn.i+d.i-cp.i):
  d*(cn+d-cp)/2
const louvainCommunityDetection=(cy,{weight,iterations,level}={})=>{
  let nodes = cy.nodes().filter(n=>n.isOrphan()&&getDegree(n,0))
  nodes.forEach((n,i)=>n.move({
    parent:cy.add({ group: 'nodes', data:{id:`L${level}-C${i}`} }).id()
  }))

  for(
    let dirty=1,loop=0,_arr=Array.from(nodes,(_,i)=>i),__l=[];
    loop<iterations&&dirty===1;
    loop++,shuffleArray(_arr),__l.length=0
  ){
    dirty=0;
    _arr.forEach(i=>{
      let dm = -1,nc=-1,de,dd;
      let node = nodes[i]
      let cp = getDegree(node.parent());
      let d = getDegree(node)
      node.descendants().add(node).neighborhood().parents().not(node.parent()).forEach(n=>{
        let cn = getDegree(n)
        let [e2cn,e2cp] = [n,node.siblings()].map(g=>
          node.descendants().add(node)
          .edgesWith(g.descendants().add(g))
          .reduce((a,e)=>a+weight(e),0)
        )
        let idm = (de = e2cn-e2cp) - (dd = degreeExchange(cn,d,cp)/m);
        if(idm>0&&idm>dm)[dm,nc] = [idm,n.id()];
        __l.push({loop,m,i,n:n.id(),nc,de,dd,d,cp,cn,e2cp,e2cn,idm,dm})
      })
      if(dm>0){
        node.move({parent:nc})
        dirty=1;
      }
    })
    //cy.nodes().filter(':childless:orphan[^name]').remove()
    cy.nodes().filter(':orphan').filter(':childless[^name]').remove()
    // console.table(__l)
    // console.table(nodes.parents().map(n=>n.descendants().filter('[name]').map(n=>n.id()).join()))
    //console.log(JSON.stringify(__l))
  }
  cy.nodes().filter(':orphan[^name]')
    .filter(n=>n.descendants().neighborhood('node').not(n.descendants()).length==0).remove()
  nodes.filter(n=>n.siblings().length==0).forEach(n=>{
    let p = n.parent()
    n.move({parent:null})
    p.remove()
  })
  return cy.nodes().filter(n=>n.isOrphan()&&getDegree(n,0)).length != nodes.length
}
module.exports = function(cy){cy('collection', 'louvain', function({
  weight=e=>e?.data('weight')??1,iterations=27,mode=1,level=1
}={}){
  let {cy} = this._private;
  m = this.edges().reduce((s,e)=>s+weight(e),0);
  edgeType = mode;
  return louvainCommunityDetection(cy,{weight,iterations,level})
})}
